export const PROJECT_ID = "project_id"
export const PROJECT_USER_ID = "project_user_id"
export const USER_IS_OWNER = "user_is_owner"
export const PROJECT_USER_ROLE = "project_user_role"
export const PREMIUM_REMINDER = "premium_reminder"
export const COMPLETE_INFO_REMINDER = "complete-info-reminder"
export const ACCESS_TOKEN = "accessToken"
export const PHONE = "phone";
export const RESET_PASS_TOKEN = "reset-pass-token";
export const FORGET_VERIFY = "forget-verify";
export const USER_VERIFY_STATE = "user_verify_state";
export const WELCOME_MODAL_USER_ID = "welcome_modal_user_id";
export const CURRENCY = "currency";

export const GO_BACK_COUNTER = "go_back_counter";

export const FAST_TUTORIAL_LINK = "web_step_by_step";

